'use client';
import dynamic from 'next/dynamic';
import React from 'react';

const MeetTheTeam = dynamic(() => import('../MeetTheTeam'), { ssr: false });

type Teams = {
  email: string;
  full_name: string;
  image_id: string;
  role: string;
  phone_number: string;
};

const MeetTheTeamDynamic = ({
  teams,
  defaultImage,
}: {
  teams: Teams[];
  defaultImage: string;
}) => {
  return <MeetTheTeam teams={teams} defaultImage={defaultImage} />;
};

export default MeetTheTeamDynamic;
